import { CommonModule } from '@angular/common';
import { Component, computed, Input, ChangeDetectionStrategy, input } from '@angular/core';
import { ViewOnlyType } from '../../models/view-only.type';
import { convertToDate, isDateFormat } from '../../../shared/utils/date.util';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewComponent {
  @Input() dataList: ViewOnlyType[] = [];
  @Input() skip: string[] = [];

  /** When true, fields with value "False", "false" or "No" are hidden (only show true booleans). */
  hideFalseBooleans = input(false);

  isGuid(value: any): boolean {
    if (!value) {
      return false;
    }
    const guidRegex =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return guidRegex.test(value.toString());
  }

  filteredDataList = computed(() => {
    const hideFalse = this.hideFalseBooleans();
    return this.dataList
      .filter((data) => {
        if (this.isGuid(data.value) || this.skip.includes(data.name)) {
          return false;
        }
        if (hideFalse && (data.value === 'False' || data.value === 'false' || data.value === 'No')) {
          return false;
        }
        return true;
      })
      .map((data: ViewOnlyType) => {
        if (data.value && isDateFormat(data.value)) {
          data.value = convertToDate(data.value);
        }
        return data;
      });
  });
}
